import React from 'react';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../store/authStore';

const GREEN = '#2e9f86';
const WHATSAPP = '96170385816'; // <-- PUT YOUR WHATSAPP NUMBER (intl, no + or spaces)

export default function Expired() {
  const navigate = useNavigate();
  const logout = useAuthStore((s) => s.logout);

  let info = {};
  try { info = JSON.parse(localStorage.getItem('expired_info') || '{}'); } catch { info = {}; }

  const waMsg = encodeURIComponent(
    `Hi, I'd like to activate my MMM POS account${info.company_name ? ' (' + info.company_name + ')' : ''}.`
  );
  const waLink = `https://wa.me/${WHATSAPP}?text=${waMsg}`;

  const backToLogin = () => {
    localStorage.removeItem('expired_info');
    logout();
    navigate('/login');
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg,#0f172a 0%,#134e4a 100%)', padding: 20, fontFamily: "'DM Sans','Segoe UI',sans-serif" }}>
      <div style={{ width: 440, maxWidth: '100%', background: '#fff', borderRadius: 18, boxShadow: '0 24px 64px rgba(0,0,0,0.35)', padding: 34, textAlign: 'center' }}>
        <div style={{ fontSize: 44, marginBottom: 8 }}>⏳</div>
        <div style={{ fontSize: 20, fontWeight: 800, color: '#111' }}>
          {info.reason === 'subscription_expired' ? 'Subscription ended' : 'Trial ended'}
        </div>
        {info.company_name && <div style={{ fontSize: 13, color: '#9ca3af', marginTop: 4 }}>{info.company_name}</div>}

        <div style={{ fontSize: 14, color: '#4b5563', margin: '16px 0 22px', lineHeight: 1.6 }}>
          {info.message || 'Your trial or subscription has ended. Contact us to activate your account and keep using MMM POS.'}
        </div>

        <a href={waLink} target="_blank" rel="noreferrer"
           style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, background: '#25D366', color: '#fff', border: 'none', borderRadius: 11, padding: '13px 0', fontSize: 15, fontWeight: 700, textDecoration: 'none' }}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M.057 24l1.687-6.163a11.867 11.867 0 01-1.587-5.946C.16 5.335 5.495 0 12.05 0a11.817 11.817 0 018.413 3.488 11.824 11.824 0 013.48 8.414c-.003 6.557-5.338 11.892-11.893 11.892a11.9 11.9 0 01-5.688-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884a9.86 9.86 0 001.51 5.26l-.999 3.648 3.978-1.607z"/></svg>
          Contact us on WhatsApp
        </a>

        <button onClick={backToLogin} style={{ width: '100%', marginTop: 12, background: '#f3f4f6', color: '#374151', border: 'none', borderRadius: 11, padding: '11px 0', fontSize: 14, fontWeight: 600, cursor: 'pointer' }}>
          Back to login
        </button>
      </div>
    </div>
  );
}